function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Controller } from "stimulus";

var _default = /*#__PURE__*/function (_Controller) {
  _inherits(_default, _Controller);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "connect",
    value: function connect() {
      console.log("Drag content block controller connected...");
    }
  }, {
    key: "dragstart",
    value: function dragstart(event) {
      event.dataTransfer.setData("application/drag-key", event.target.closest(".content-block").getAttribute("data-content-block-id"));
      event.dataTransfer.effectAllowed = "move";
    }
  }, {
    key: "dragover",
    value: function dragover(event) {
      event.preventDefault();
      return true;
    }
  }, {
    key: "dragenter",
    value: function dragenter(event) {
      event.preventDefault();
    }
  }, {
    key: "drop",
    value: function drop(event) {
      var data = event.dataTransfer.getData("application/drag-key");
      var dropTarget = event.target;
      var draggedItem = this.element.querySelector("[data-content-block-id='".concat(data, "']"));
      var positionComparison = dropTarget.compareDocumentPosition(draggedItem);

      if (positionComparison & 4) {
        event.target.closest('.content-block').insertAdjacentElement('beforebegin', draggedItem);
      } else if (positionComparison & 2) {
        event.target.closest('.content-block').insertAdjacentElement('afterend', draggedItem);
      }

      event.preventDefault();
    }
  }, {
    key: "dragend",
    value: function dragend(event) {
      var rows = event.target.closest('#contentBlocks');
      var row = rows.getElementsByClassName('content-block');
      var new_positions = [];

      for (var i = 0; i < row.length; i++) {
        new_positions.push(parseInt(row[i].getAttribute('data-content-block-id'), 10));
      }

      $.ajax({
        url: event.target.closest('.content-block').getAttribute('data-url'),
        type: "PATCH",
        data: {
          new_positions: new_positions
        }
      });
    }
  }]);

  return _default;
}(Controller);

export { _default as default };